import { GridColumnVisibilityModel } from "@mui/x-data-grid";
import { AppFilterItem } from "./AppModels";

export enum AppGridId {
  Product_Sync_Wholegoods,
  Product_Sync_Parts,
  Product_Manager_Wholegoods,
  Product_Manager_Parts,
  ReInitiate_Setup_DMS_Products,
  Initiate_Parts_DMS_Parts,
  New_Products,
  Used_Products,
  DMS_Products,
  Customers,
  Quotations,
  Orders,
  DMS_Manufacturers,
  Create_Setup_DMS_Products,
  Create_Setup_Matched_Products,
  Create_Setup_Not_Matched_Products,
  Create_Setup_Shopify_Initialization,
  Catalogue_Products,
  Catalogue_Parts,
  Dashboard_Cards,
  Archived_Orders,
}
export const GridIdsToSave: AppGridId[] = [
  AppGridId.Product_Sync_Wholegoods,
  AppGridId.Product_Sync_Parts,
  AppGridId.Product_Manager_Wholegoods,
  AppGridId.Product_Manager_Parts,
  AppGridId.New_Products,
  AppGridId.Used_Products,
  AppGridId.DMS_Products,
  AppGridId.Customers,
  AppGridId.Quotations,
  AppGridId.Orders,
  AppGridId.Archived_Orders,
];

export interface AppGridSettingDto {
  userId: string;
  gridId: AppGridId;
  setting: string;
}

export interface AppFilterSettings {
  pageIndex?: number;
  pageSize?: number;
  totalRecords?: number;
  items: AppFilterItem[];
  quickFilterValues?: string[];
  logicalOperator: string;
  filterShortcutName?: string;
  isShortcut?: boolean;
  description?: string;
  imageUri?: string;
}

export interface AppGridSetting {
  gridId: AppGridId;
  columnVisibilityModel?: GridColumnVisibilityModel;
  filterSettings?: AppFilterSettings[];
}

export const MaxSavedFilters = 25;
export interface AppGridSettingState {
  setting: AppGridSetting[];
  hasUnsavedChanges?: boolean;
}

export const AppGridSettingInitialState: AppGridSettingState = {
  setting: [],
  hasUnsavedChanges: undefined,
};
